import React, { useState, useEffect, useMemo, useRef } from 'react';
import { StyleSheet, FlatList, ScrollView } from 'react-native';
import { useParams } from "react-router-dom";
import { loadSurvey, loadSurveyResponses, getNumberOfUsersForSurveyResponses, getResponsesForChart } from "../../../services/SurveyService";
import CustomSurvey from '../../../components/SurveyBuilderComponent/Survey/CustomSurvey';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import Pagination from '../../../components/Pagination/pagination';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import { Chart } from "react-google-charts";
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';

// import '../App.css';
// import JsPDF from 'jspdf';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { SafeAreaView } from 'react-native';

let PageSize = 1;

const ResultsSurvey = (props) => {

    //#region Const definitions and states
    const { user, clientApi } = useAuthContext();
    const { t } = useTranslation();
    const { colors } = useTheme()
    const styles = makeStyles(colors)

    const resultTypeList = [
        { label: t('common:surveyResults'), value: 'SurveyResults' },
        { label: t('common:analytics'), value: 'Analytics' },
    ];

    // * Get ID of Survey to load 
    const survId = props.survId;

    // TODO Change organization id when you want to support multiCple companies
    const [survey, setSurvey] = useState({})
    const [requireLogin, setRequireLogin] = useState('')
    // * state array of section each section contains array of questions 
    const [sectionQuestionList, setSectionQuestionList] = useState([])

    // * State for Result View 
    const [resultView, setResultView] = useState('');
    const [chartValue, setChartValue] = useState('PieChart');

    // * Get Responses form Db 
    const [questionOptionResponseList, setQuestionOptionResponseList] = useState([])
    const questionOptionResponseListRef = useRef([])
    // * Distinguish unique users from the above for the pages of responses 
    const [responseUserIds, setResponseUserIds] = useState([])
    const [noOfUsers, setNoOfUsers] = useState(0)

    // * Get Sections if Completed On time is required
    const [userSurveySectionList, setUserSurveySectionList] = useState([])

    // * Use for pagination of results, 1 page per survey
    const [currentPage, setCurrentPage] = useState(0);

    const pdfRef = useRef(null);


    // TODO Generate PDF export -- Draft1 :)
    // const generatePDFDraft1 = async () => {
    //     console.log(0)
    //     const input = pdfRef.current;
    //     const pdf = new JsPDF('p', 'pt', 'a4');

    //     const widthPdf = pdf.internal.pageSize.getWidth();
    //     const heightPdf = pdf.internal.pageSize.getHeight();

    //     const capture = async (yOffset) => {
    //         const canvas = await html2canvas(input, {
    //             windowHeight: input.offsetHeight - yOffset,
    //             windowWidth: input.offsetWidth,
    //             scrollY: yOffset
    //         })
    //         console.log()

    //         const imgData = canvas.toDataURL('image/png');
    //         pdf.addImage(imgData, 'PNG',0,0,widthPdf,heightPdf, undefined,'FAST')

    //         if (canvas.height + yOffset < input.offsetHeight){
    //             pdf.addPage()
    //             capture(yOffset + canvas.height);
    //         }else {
    //             pdf.save('Analytics.pdf')
    //         }
    //     };
    //     capture(0)
    // };

    // TODO Generate PDF export -- Draft2 :)
    //     const generatePDFDraft2 = async () => {
    //         console.log('pdfclick')
    // //WORKS
    //         // console.log(container)
    //         html2canvas(container).then((canvas) => {
    //             const imgData = canvas.toDataURL('image/png');
    //             console.log(imgData)
    //             const pdf = new JsPDF();
    //             //pdf sizing
    //             const widthPdf = pdf.internal.pageSize.getWidth();
    //             const heightPdf = pdf.internal.pageSize.getHeight();

    //             //data of page sizing
    //             const heightContent = container.clientHeight;

    //             const heightContentOld = (canvas.height * widthPdf) /canvas.width;

    //             //calculate no of pages to split into
    //             const totalPages = Math.ceil(heightContent/heightPdf);

    //             let currentPos = 0;
    //             let heightLeft = heightContent;

    //             console.log(totalPages)
    //             //loop pages and add appropriate data to each
    //             for (let i=0; i<totalPages; i++){
    //                 pdf.addImage(imgData,'PNG', 0, -currentPos, widthPdf, heightPdf);
    //                 heightLeft -= heightPdf
    //                 currentPos += heightPdf

    //                 if(heightLeft >0){
    //                     pdf.addPage();
    //                 }
    //             }
    //             pdf.save('Analytics.pdf');
    //         });

    //     }

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        return responseUserIds.slice(firstPageIndex, lastPageIndex);
    }, [currentPage]);

    const handleResultViewChange = (e) => {
        setCurrentPage(1)
        setResultView(e)
    }
    const handleChartViewChange = (e) => {
        const { value } = e.target;
        setChartValue(value)
    }

    const [chartData, setChartData] = useState([])
    const chartDataRef = useRef([])
    const [chartOptions, setChartOptions] = useState([])
    const chartOptionsRef = useRef([])
    //#endregion

    useEffect(() => {
        // console.log(survId)
        loadSurvey(clientApi, survId, user.token)
            .then(respSurvey => {
                setSurvey(respSurvey.sh)
                setSectionQuestionList(respSurvey.ss)
                setRequireLogin(respSurvey.sh.require_login)

                // * Load Results for surveys   
                loadSurveyResponses(clientApi, survId, user.token)
                    .then(responses => {
                        setQuestionOptionResponseList(responses)
                        questionOptionResponseListRef.current = responses;
                        getNumberOfUsersForSurveyResponses(clientApi, survId, user.token)
                            .then(responseUserid => {
                                setResponseUserIds(responseUserid)
                                setNoOfUsers(responseUserIds.length)

                                // * Load Chart data 
                                getResponsesForChart(clientApi, survId, user.token)
                                    .then(chartItr => {
                                        let tempOptions = [];
                                        chartItr.qo.map((qoItr) => {
                                            tempOptions.push({ title: qoItr.question_name })
                                        })
                                        setChartOptions(tempOptions)
                                        chartOptionsRef.current = tempOptions
                                        setChartData(chartItr.cqos);
                                        chartDataRef.current = chartItr.cqos;
                                    }).catch(error => {
                                        console.log(error)
                                    });
                            }).catch(error => {
                                console.log(error)
                            });

                        // TODO load user section as well for completion maybe not needed ? 
                    }).catch(error => {
                        console.log(error)
                    });

            }).catch(error => {
                console.log(error)
            });
    }, []);

    return (
        <SafeAreaView
            style={styles.main}>
            <ScrollView>
                <SafeAreaView
                    style={styles.dropDownView}>
                    <CustomDropDown
                        defValue={resultView}
                        options={resultTypeList}
                        value={resultView}
                        setValue={(e) => handleResultViewChange(e)}
                        type='FULL'
                    />
                </SafeAreaView>
                {resultView === "SurveyResults" &&
                    <CustomLabel
                        value={t('common:resultsPerCandidate')}
                        type='MINORTITLE' />
                }
                {resultView === "Analytics" &&
                    <CustomLabel
                        value={t('common:surveyAnalytics')}
                        type='MINORTITLE' />
                }
                {resultView === "SurveyResults" &&
                    <Pagination
                        currentPage={currentPage}
                        totalCount={responseUserIds.length}
                        pageSize={PageSize}
                        onPageChange={page => setCurrentPage(page)}
                    />
                }
                <SafeAreaView>
                    {resultView === "SurveyResults" &&
                        <SafeAreaView
                            style={styles.dropDownView}>
                            <FlatList
                                data={currentTableData}
                                contentContainerStyle={{ alignSelf: 'flex-start' }}
                                horizontal={true}
                                showsVerticalScrollIndicator={true}
                                showsHorizontalScrollIndicator={true}
                                persistentscrollbar={true}
                                renderItem={({ item, index }) => {
                                    const currUserQuesOptionRespList = [];
                                    questionOptionResponseList.map((qorItr) => {
                                        if (qorItr.user_id === item.user_id) {
                                            currUserQuesOptionRespList.push(qorItr)
                                        }
                                    })
                                    return (
                                        <CustomSurvey
                                            survey={survey}
                                            setSurvey={setSurvey}
                                            sectionQuestionList={sectionQuestionList}
                                            setSectionQuestionList={setSectionQuestionList}
                                            questionOptionResponseList={currUserQuesOptionRespList}
                                            setQuestionOptionResponseList={setQuestionOptionResponseList}
                                            userSurveySectionList={userSurveySectionList}
                                            isEdit={0}
                                            isResult={1}
                                            isResponse={1}
                                        />)
                                }}
                                style={{ flex: 1 }}
                                // onRefresh={() => GetLeaveAnalysis()}
                                // refreshing={isLoading}
                                keyExtractor={item => `${item.id}`}
                            />
                        </SafeAreaView>
                    }
                    {resultView === "Analytics" &&
                        <SafeAreaView>
                            {/* <FlatList
                            data={currentTableData}
                            contentContainerStyle={{ alignSelf: 'flex-start' }}
                            horizontal={true}
                            showsVerticalScrollIndicator={true}
                            showsHorizontalScrollIndicator={true}
                            persistentscrollbar={true}
                            renderItem={({ item, index }) => {
                                const currUserQuesOptionRespList = [];
                                questionOptionResponseList.map((qorItr) => {
                                    if (qorItr.user_id === item.user_id) {
                                        currUserQuesOptionRespList.push(qorItr)
                                    }
                                })
                                
                                return ( */}
                            <CustomSurvey
                                survey={survey}
                                setSurvey={setSurvey}
                                sectionQuestionList={sectionQuestionList}
                                setSectionQuestionList={setSectionQuestionList}
                                questionOptionResponseList={questionOptionResponseListRef}
                                setQuestionOptionResponseList={setQuestionOptionResponseList}
                                chartOptions={chartOptionsRef.current}
                                userSurveySectionList={userSurveySectionList}
                                noOfUsers={noOfUsers}
                                chartData={chartDataRef.current}
                                isEdit={0}
                                isResult={1}
                                isResponse={1}
                                isAnalytics={1} />
                            {/* )
                            }}
                            style={{ flex: 1 }}
                            // onRefresh={() => GetLeaveAnalysis()}
                            // refreshing={isLoading}
                            keyExtractor={item => `${item.id}`}
                        /> */}
                        </SafeAreaView>
                    }
                </SafeAreaView>
            </ScrollView>
        </SafeAreaView>
    );
};

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
    },
    dropDownView: {
        alignSelf: 'center'
    },
});
export default ResultsSurvey; 